import React, { useState } from 'react';
import Fuse from 'fuse.js';
import { Search, X } from 'lucide-react';

const SearchBar = ({ jobs, onSearchResults }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredCount, setFilteredCount] = useState(jobs.length);

  // Configure Fuse.js options
  const fuseOptions = {
    keys: [
      'title',
      'company',
      'location',
      'description'
    ],
    threshold: 0.3,
    includeScore: true,
    includeMatches: true
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (!value.trim()) {
      onSearchResults(jobs);
      setFilteredCount(jobs.length);
      return;
    }

    const fuse = new Fuse(jobs, fuseOptions);
    const results = fuse.search(value);
    // Preserve all original job data
    const filteredJobs = results.map(result => ({
      ...result.item
    }));
    setFilteredCount(filteredJobs.length);
    onSearchResults(filteredJobs);
  };

  const clearSearch = () => {
    setSearchTerm('');
    onSearchResults(jobs);
    setFilteredCount(jobs.length);
  };

  return (
    <div className="search-container">
      <div className="search-input-wrapper">
        <Search className="search-icon" />
        <input
          type="text"
          placeholder="Search jobs by title, company, or location..."
          value={searchTerm}
          onChange={handleSearch}
          className="search-input"
        />
        {searchTerm && (
          <button 
            className="clear-search"
            onClick={clearSearch}
          >
            <X className="icon" />
          </button>
        )}
      </div>
      {searchTerm && (
        <div className="search-stats">
          Found {filteredCount} matching jobs
        </div>
      )}
    </div>
  );
};

export default SearchBar;
